import TabsWithBadge from "V2.0/common/tabsWithBadge";
import {
  Table,
  TableHead,
  TableBody,
  TableHeader,
  TableRow,
  TableCell,
} from "V2.0/common/table";

function PhoneNumbersTable(props) {
  const { phoneNumbers } = props;

  return (
    <Table>
      <TableHead>
        <TableHeader>Number</TableHeader>
      </TableHead>
      <TableBody>
        {phoneNumbers.map((phoneNumber) => {
          return (
            <TableRow key={phoneNumber}>
              <TableCell>{phoneNumber}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}

export default function MCubeEngageWhatsappPhoneNumbers(props) {
  const { configuration, tabs, setActiveTab } = props;
  const { phoneNumbers } = configuration;

  return (
    <>
      <div className="flex flex-col w-2/3 border rounded-lg h-full">
        <div className="flex-shrink-0 flex justify-between items-center px-4 bg-gray-50 rounded-t-lg w-full">
          <TabsWithBadge
            className="flex-shrink-0"
            tabs={tabs}
            onTabChange={(e, { tab, index }) => setActiveTab(tab.name)}
          />
        </div>
        <div className="flex-1 min-h-[600px] p-4 overflow-y-scroll">
          <PhoneNumbersTable phoneNumbers={phoneNumbers} />
        </div>
      </div>
    </>
  );
}
